import { EdgelessMinimapCanvas } from './minimap-canvas';

export function effects() {
  customElements.define('edgeless-minimap-canvas', EdgelessMinimapCanvas);
}
